import React, { Component } from "react";
import { Button, Form, FormGroup, Label, Input } from "reactstrap";
import axios from "axios";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3030";

class Signin extends Component {
  constructor() {
    super();
    this.state = {
      username: "",
      password: "",
      isLogin: false,
      isValidPassword: true
    };
    this.handleChangeUsername = this.handleChangeUsername.bind(this);
    this.handleChangePassword = this.handleChangePassword.bind(this);
    this.submitForm = this.submitForm.bind(this);
  }

  handleChangeUsername(event) {
    let value = event.target.value;
    this.setState(() => {
      return { username: value };
    });
  }

  handleChangePassword(event) {
    let value = event.target.value;
    this.setState(() => {
      return { password: value };
    });
  }

  async submitForm(e) {
    e.preventDefault();
    await axios
      .post(`${API_URL}/accounts/signin`, {
        username: this.state.username,
        password: this.state.password
      })
      .then(res => {
        if (res.data.token) {
          window.localStorage.id = res.data.id;
          window.localStorage.token = res.data.token;
          window.localStorage.userId = res.data.userId;
          //redirect here
          this.setState({ isValidPassword: true });
          this.props.history.push(`/`);
        } else {
          this.setState({ isValidPassword: false });
        }
      })
      .catch(error => {
        console.log(error.res);
      });
  }

  render() {
    return (
      <div>
        <div className="center">
          <h1>Welcome to Foodbook</h1>
        </div>
        <div className="center">
          <h3>Please sign in to access your account</h3>
        </div>

        <div>
          <div className="center">
            <div className="Container">
              <Form onSubmit={this.submitForm}>
                <FormGroup>
                  <Label htmlFor="exampleEmail">Username</Label>
                  <Input
                    type="text"
                    name="userid"
                    placeholder="Your username"
                    value={this.state.username}
                    onChange={this.handleChangeUsername}
                  />
                </FormGroup>
                <FormGroup>
                  <Label htmlFor="examplePassword">Password</Label> &nbsp;&nbsp;
                  {this.state.isValidPassword ? (
                    <span />
                  ) : (
                    <span className="invalid-pas-notif">
                      (Your Password or Email is Invalid)
                    </span>
                  )}
                  <Input
                    type="password"
                    name="password"
                    placeholder="Your password"
                    value={this.state.password}
                    onChange={this.handleChangePassword}
                  />
                </FormGroup>
                <Button outline color="danger" size="lg" block>
                  Sign In
                </Button>
              </Form>
            </div>
          </div>

          <div>
            <h6 className="center">
              Don't have an account?{" "}
              <Link to="/signup">
                <h6>Sign up now</h6>
              </Link>
            </h6>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Signin);



// WEBPACK FOOTER //
// ./src/page/Signin.jsx